"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tenantShape = exports.queryParametersShape = exports.claimShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var ClaimConstants = _interopRequireWildcard(require("./constants/claims"));

var claimShape = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  status: _propTypes["default"].oneOf([ClaimConstants.OPEN, ClaimConstants.REJECTED, ClaimConstants.RESOLVED]),
  responsibleParty: _propTypes["default"].oneOf(ClaimConstants.RESPONSIBLE_PARTIES),
  preferredResolution: _propTypes["default"].oneOf(ClaimConstants.RESOLUTIONS),
  merchantClaimCategories: _propTypes["default"].arrayOf(_propTypes["default"].string),
  assignee: _propTypes["default"].oneOf([ClaimConstants.MERCHANT, ClaimConstants.FULFILLER]),
  merchantId: _propTypes["default"].string,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    itemId: _propTypes["default"].string.isRequired,
    quantity: _propTypes["default"].number
  })),
  created: _propTypes["default"].string,
  _links: _propTypes["default"].shape({
    self: _propTypes["default"].shape({
      href: _propTypes["default"].string
    })
  })
});

exports.claimShape = claimShape;

var queryParametersShape = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  assignee: _propTypes["default"].arrayOf(_propTypes["default"].oneOf([ClaimConstants.MERCHANT, ClaimConstants.FULFILLER])),
  fulfillerId: _propTypes["default"].arrayOf(_propTypes["default"].string),
  globalFulfillerId: _propTypes["default"].arrayOf(_propTypes["default"].string),
  fulfillmentLocationId: _propTypes["default"].arrayOf(_propTypes["default"].string),
  itemId: _propTypes["default"].arrayOf(_propTypes["default"].string),
  limit: _propTypes["default"].number,
  merchantId: _propTypes["default"].arrayOf(_propTypes["default"].string),
  offset: _propTypes["default"].number,
  orderId: _propTypes["default"].arrayOf(_propTypes["default"].string),
  responsibleParty: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(ClaimConstants.RESPONSIBLE_PARTIES)),
  status: _propTypes["default"].arrayOf(_propTypes["default"].oneOf([ClaimConstants.OPEN, ClaimConstants.REJECTED, ClaimConstants.RESOLVED])),
  lastUpdatedStartDate: _propTypes["default"].string,
  lastUpdatedEndDate: _propTypes["default"].string
});

exports.queryParametersShape = queryParametersShape;

var tenantShape = _propTypes["default"].shape({
  tenantType: _propTypes["default"].oneOf([ClaimConstants.MERCHANT, ClaimConstants.FULFILLER]).isRequired,
  tenantValue: _propTypes["default"].string.isRequired
});

exports.tenantShape = tenantShape;